import React, { useState } from 'react'
import SaveMixModal from './SaveMixModal'
import { useDispatch, useSelector } from 'react-redux';
import { handleCreatePlaylistModal, handleEditPlaylistModal, handleRemovePlaylistModal, handleSaveMixModal, handleShareMixModal, handleShareMixOnSave, handleSuccessModal } from '../../Store/Slices/ModalSlice';
import SuccessModal from './SuccessModal';
import ShareMixModal from './ShareMixModal';
import CreatePlaylistModal from './CreatePlaylistModal';
import EditPlaylistModal from './EditPlaylistModal';
import RemovePlaylistModal from './RemovePlaylistModal';
import { areAllModalsClosed } from '../../Util/helpers';
import { EventEmitter } from '../../Services/RefreshObservable';
import { t } from 'i18next';
import { setSelectedId } from '../../Store/Slices/PlayerSlice';

const GlobalModals = () => {

    const dispatch = useDispatch();


    const modalState = useSelector((state) => state.modal);
    const userPrompts = useSelector((state) => state.user.userPrompts);

    const isSucessModal = useSelector((state) => state.modal.isSucessModal);
    const isOpenSaveMixModal = useSelector((state) => state.modal.isOpenSaveMixModal);
    const isOpenShareMixModal = useSelector((state) => state.modal.isOpenShareMixModal);
    const isShareMixOnSave = useSelector((state) => state.modal.isShareMixOnSave);
    const isOpenCreatePlaylistModal = useSelector((state) => state.modal.isOpenCreatePlaylistModal);
    const isOpenEditPlaylistModal = useSelector((state) => state.modal.isOpenEditPlaylistModal);
    const isOpenRemovePlaylistModal = useSelector((state) => state.modal.isOpenRemovePlaylistModal);

    // ✅ Get tracks from store
    const playingTracks = useSelector((state) => state.player.playingTracks);
    const selectedItem = useSelector((state) => state.player.selectedItem);
    const shareSystemCreatedPlaylist = useSelector((state) => state.player.shareSystemCreatedPlaylist);

    const config = useSelector((state) => state.player.config);

    const handleClose = (value) => {
        switch (value) {
            case "save-mix":
                dispatch(handleSaveMixModal(false));
                break;
            case "share-mix":
                dispatch(handleShareMixOnSave(false));
                dispatch(handleShareMixModal(false));
                break;
            case "create-playlist":
                dispatch(handleCreatePlaylistModal(false));
                break;
            case "edit-playlist":
                dispatch(handleEditPlaylistModal(false));
                break;
            case "remove-playlist":
                dispatch(handleRemovePlaylistModal(false));
                break;

            default:
                break;
        }
    }

    const openSuccessModal = (type) => {
        switch (type) {
            case "save-mix-created":
                handleClose('save-mix');
                dispatch(
                    handleSuccessModal({
                        msg: userPrompts?.mix_saved_notification || "Mix Created Successfully",
                        open: true
                    })
                );
                break;
            case "playlist-created":
                handleClose('create-playlist');
                dispatch(
                    handleSuccessModal({
                        msg: t("playlists.playlist_created_notification"),
                        open: true
                    })
                );
                EventEmitter({ from: "Global_Modals", to: "Playlist Screen", componentKey: 'CREATE_PLAYLIST_MODAL', isRefresh: true, time: Date.now() });
                break;
            case "updated-playlist":
                handleClose('edit-playlist');
                dispatch(
                    handleSuccessModal({
                        msg: t(shareSystemCreatedPlaylist ? "playlists.playlist_created_notification" : "playlists.playlist_updated_notification"),
                        open: true
                    })
                );
                dispatch(setSelectedId(null));
                EventEmitter({ from: "Global_Modals", to: "Playlist Screen", componentKey: 'UPDATE_PLAYLIST_MODAL', isRefresh: true, time: Date.now() });
                break;
            case "removed-playlist":
                handleClose('remove-playlist');
                dispatch(
                    handleSuccessModal({
                        msg: t("playlists.playlist_deleted_notification"),
                        open: true
                    })
                );
                EventEmitter({ from: "Global_Modals", to: "Playlist Screen", componentKey: 'REMOVE_PLAYLIST_MODAL', isRefresh: true, time: Date.now() });
                break;
            case "removed":
                break;
        }
        setTimeout(() => {
            dispatch(
                handleSuccessModal({
                    msg: "",
                    open: false
                })
            );
            if (isShareMixOnSave) {
                dispatch(handleShareMixModal(true));
            }
        }, 1500);
    };

    if (areAllModalsClosed(modalState)) return null;

    return (
        <>
            <SaveMixModal
                isOpen={isOpenSaveMixModal}
                onClose={handleClose}
                onSuccess={openSuccessModal}
                tracks={playingTracks}
                config={config}
            />
            <ShareMixModal
                isOpen={isOpenShareMixModal}
                onClose={handleClose}
                tracks={playingTracks}
            />
            <CreatePlaylistModal
                isOpen={isOpenCreatePlaylistModal}
                onClose={handleClose}
                onSuccess={openSuccessModal}
                tracks={playingTracks}
            />
            <EditPlaylistModal
                isOpen={isOpenEditPlaylistModal}
                onClose={handleClose}
                onSuccess={openSuccessModal}
            />
            <RemovePlaylistModal
                isOpen={isOpenRemovePlaylistModal}
                onClose={handleClose}
                config={config}
                onSuccess={openSuccessModal}
            />
            <SuccessModal
                isOpen={isSucessModal?.open}
                prompt={isSucessModal?.msg}
            />
        </>
    )
}

export default GlobalModals